<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ pageTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">发布招标公告</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <el-button type="primary" icon="el-icon-plus" @click="handleAddNew('new')">新增招标公告</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column type="index" label="NO." width="60" align="center">
                    <template slot-scope="scope"> {{ scope.$index + 1 }} </template>
                </el-table-column>
                <el-table-column prop="tenderNoticeName" label="公告名称" show-overflow-tooltip />
                <el-table-column prop="tenderNoticeCode" label="公告编码" show-overflow-tooltip />
                <el-table-column prop="noticeSendTime" label="发布日期" width="180" align="center" />
                <el-table-column prop="noticeNature" label="公告性质" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ noticeNatureDict[scope.row.noticeNature] || scope.row.noticeNature }}
                    </template>
                </el-table-column>
                <el-table-column prop="noticeNature" label="公告类型" show-overflow-tooltip>
                    <template>
                        招标公告
                    </template>
                </el-table-column>

                <el-table-column prop="status" label="发布状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ statusDict[scope.row.status] || scope.row.status }}
                    </template>
                </el-table-column>
                <el-table-column prop="auditOpinion" label="审核意见" show-overflow-tooltip />
                <el-table-column label="详细信息" align="center" width="200">
                    <template slot-scope="scope">
                        <!-- status = 0: 显示编辑和删除 -->
                        <template v-if="scope.row.status === 0">
                            <el-button type="text" size="small" @click="handleEdit(scope.row)" class="action-btn">
                                编辑
                            </el-button>
                            <el-button type="text" size="small" @click="handleDelete(scope.row)"
                                class="action-btn delete-btn">
                                删除
                            </el-button>
                        </template>
                        <!-- status = 1: 显示详情 -->
                        <template v-else-if="scope.row.status === 1">
                            <el-button type="text" size="small" @click="handleViewDetail(scope.row)" class="action-btn">
                                详情
                            </el-button>
                        </template>
                        <!-- status = 2: 显示修改和删除 -->
                        <template v-else-if="scope.row.status === 2">
                            <el-button type="text" size="small" @click="handleEdit(scope.row)" class="action-btn">
                                修改
                            </el-button>
                            <el-button type="text" size="small" @click="handleDelete(scope.row)"
                                class="action-btn delete-btn">
                                删除
                            </el-button>
                        </template>
                        <!-- status = 9: 根据 noticeNature 显示不同操作 -->
                        <template v-else-if="scope.row.status === 9">
                            <el-button type="text" size="small" @click="handleViewDetail(scope.row)" class="action-btn">
                                详情
                            </el-button>
                            <!-- noticeNature = 1: 显示变更公告 -->
                            <el-button v-if="scope.row.noticeNature == 1" type="text" size="small"
                                @click="handleChangeAnnouncement(scope.row)" class="action-btn">
                                变更公告
                            </el-button>
                        </template>
                        <!-- 默认情况: 显示详情 -->
                        <template v-else>
                            <el-button type="text" size="small" @click="handleViewDetail(scope.row)" class="action-btn">
                                详情
                            </el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 详情弹窗 -->
        <el-dialog title="招标公告详情" :visible.sync="detailDialogVisible" width="75%" :close-on-click-modal="false"
            :append-to-body="true" custom-class="detail-dialog-panel" class="detail-dialog">
            <div class="detail-content" v-if="currentDetail">
                <div class="detail-overview">
                    <div class="overview-main">
                        <div class="overview-title">{{ currentDetail.tenderNoticeName || '-' }}</div>
                        <div class="overview-code">公告编码：{{ currentDetail.tenderNoticeCode || '-' }}</div>
                        <div class="overview-submeta">
                            <div class="overview-stat">
                                <span class="stat-label">涉及标段</span>
                                <strong class="stat-value">{{ getBidSectionList(currentDetail).length }}</strong>
                            </div>
                            <div class="overview-stat">
                                <span class="stat-label">发布时间</span>
                                <strong class="stat-value stat-value--time">{{ currentDetail.noticeSendTime || '-' }}</strong>
                            </div>
                            <div class="overview-stat">
                                <span class="stat-label">截标时间</span>
                                <strong class="stat-value stat-value--time">{{ currentDetail.bidDocumentSubmissionDeadline || '-' }}</strong>
                            </div>
                        </div>
                    </div>
                    <div class="overview-meta">
                        <!-- <el-tag :type="getStatusType(currentDetail.status)" size="small" effect="plain">
                            {{ statusDict[currentDetail.status] || '-' }}
                        </el-tag> -->
                        <!-- <el-tag size="small" effect="plain">
                            {{ noticeTypeDict[currentDetail.noticeType] || '-' }}
                        </el-tag> -->
                        <el-tag size="small" effect="plain">
                            {{ noticeNatureDict[currentDetail.noticeNature] || '-' }}
                        </el-tag>
                    </div>
                </div>

                 <div class="detail-panel">
                    <div class="panel-title">公告涉及标段</div>
                    <el-table v-if="getBidSectionList(currentDetail).length" :data="getBidSectionList(currentDetail)" border stripe class="section-table">
                        <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
                        <el-table-column label="标段编号" prop="bidSectionCode" min-width="220" show-overflow-tooltip></el-table-column>
                        <el-table-column label="标段名称" prop="bidSectionName" min-width="260" show-overflow-tooltip></el-table-column>
                    </el-table>
                    <div v-else class="empty-state">暂无标段信息</div>
                </div>

                <div class="detail-panel">
                    <div class="panel-title">公告信息</div>
                    <div class="detail-grid detail-grid--compact">
                        <div class="detail-field">
                            <div class="field-label">公告性质</div>
                            <div class="field-value">{{ noticeNatureDict[currentDetail.noticeNature] || '-' }}</div>
                        </div>
                        <div class="detail-field">
                            <div class="field-label">公告类型</div>
                            <div class="field-value">{{ noticeTypeDict[currentDetail.noticeType] || '-' }}</div>
                        </div>
                        <div class="detail-field">
                            <div class="field-label">发布状态</div>
                            <div class="field-value">{{ statusDict[currentDetail.status] || '-' }}</div>
                        </div>
                        <!-- <div class="detail-field">
                            <div class="field-label">是否涉密</div>
                            <div class="field-value">{{ isConfidentialDict[currentDetail.isConfidential] || '-' }}</div>
                        </div> -->
                        <div class="detail-field field-span-2">
                            <div class="field-label">原公告编号</div>
                            <div class="field-value is-mono">{{ currentDetail.originalNoticeCode || '-' }}</div>
                        </div>
                    </div>
                </div>

                <div class="detail-panel">
                    <div class="panel-title">时间与流程</div>
                    <div class="detail-grid">
                        <div class="detail-field">
                            <div class="field-label">公告发布时间</div>
                            <div class="field-value is-mono">{{ currentDetail.noticeSendTime || '-' }}</div>
                        </div>
                        <!-- <div class="detail-field">
                            <div class="field-label">公告结束时间</div>
                            <div class="field-value is-mono">{{ currentDetail.noticeEndTime || '-' }}</div>
                        </div> -->
                        <div class="detail-field">
                            <div class="field-label">招标文件获取开始时间</div>
                            <div class="field-value is-mono">{{ currentDetail.biddingDocumentAcquisitionStartTime || '-' }}</div>
                        </div>
                        <div class="detail-field">
                            <div class="field-label">招标文件获取结束时间</div>
                            <div class="field-value is-mono">{{ currentDetail.biddingDocumentAcquisitionEndTime || '-' }}</div>
                        </div>
                        <div class="detail-field">
                            <div class="field-label">招标文件获取范围</div>
                            <div class="field-value">获取期</div>
                        </div>
                        <!-- <div class="detail-field">
                            <div class="field-label">招标文件获取方式</div>
                            <div class="field-value">{{ currentDetail.biddingDocumentAcquisitionMethod || '-' }}</div>
                        </div> -->
                        <!-- <div class="detail-field field-span-2">
                            <div class="field-label">投标文件递交方式</div>
                            <div class="field-value">{{ currentDetail.bidDocumentSubmissionMethod || '-' }}</div>
                        </div> -->
                        <div class="detail-field field-span-2">
                            <div class="field-label">投标文件递交截止时间</div>
                            <div class="field-value is-mono">{{ currentDetail.bidDocumentSubmissionDeadline || '-' }}</div>
                        </div>
                    </div>
                </div>

                <div class="detail-panel">
                    <div class="panel-title">操作记录</div>
                    <div class="detail-grid">
                        <!-- <div class="detail-field">
                            <div class="field-label">创建人</div>
                            <div class="field-value">{{ currentDetail.createBy || '-' }}</div>
                        </div> -->
                        <div class="detail-field">
                            <div class="field-label">创建时间</div>
                            <div class="field-value is-mono">{{ currentDetail.createTime || '-' }}</div>
                        </div>
                        <div class="detail-field field-span-2">
                            <div class="field-label">审核时间</div>
                            <div class="field-value is-mono">{{ currentDetail.auditTime || '-' }}</div>
                        </div>
                    </div>
                </div>

                <div class="detail-panel">
                    <div class="panel-title">公告内容</div>
                    <div class="content-box">
                        <div v-html="currentDetail.noticeContent || '-'" class="notice-content"></div>
                    </div>
                </div>

                <div class="detail-panel" v-if="currentDetail.remark">
                    <div class="panel-title">备注</div>
                    <div class="remark-box">{{ currentDetail.remark }}</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false" size="medium">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getTenderNoticeList, getTenderNoticeDetail, deleteTenderNotice, getProjectDetail } from '@/api/agent/api'
export default {
    name: 'PublishTenderAnnouncement',
    data() {
        return {
            // 页面基础信息
            pageTitle: '',
            projectCode: '',
            // 项目详情数据
            projectDetail: {},
            loading: false,
            // 数据字典
            noticeNatureDict: {
                1: '正常公告',
                2: '变更公告'
            },
            noticeTypeDict: {
                1: '招标公告',
                2: '资格预审公告',
                3: '中标公告',
                9: '其他'
            },
            statusDict: {
                0: '暂存',
                1: '提交',
                2: '退回',
                9: '发布'
            },
            biddingDocumentAcquisitionScopeDict: {
                1: '公告期',
                2: '文件获取期'
            },
            isConfidentialDict: {
                0: '不包含',
                1: '包含'
            },
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 1
            },
            detailDialogVisible: false,
            currentDetail: null
        }
    },
    mounted() {
        this.projectCode = this.$route.query.projectCode
        this.initPage()

    },
    methods: {
        /**
         * 初始化页面
         */
        initPage() {
            const projectCode = this.$route.query.projectCode
            if (!projectCode) {
                this.$message.error('缺少项目编号参数')
                this.$router.go(-1)
                return
            }

            this.projectCode = projectCode
            this.loadData()
            this.loadTenderNoticeList()
        },
        /**
         * 加载数据
         */
        async loadData() {
            const res = await getProjectDetail({ projectCode: this.projectCode })
            if (res.code === 200) {
                this.projectDetail = res.data
                this.pageTitle = this.$getProjectTypeName(res.data.projectType) + '--招标项目编号：' + res.data.projectCode + '　招标项目名称：' + res.data.projectName
            } else {
                this.$message.error('项目详情接口失败')
            }
        },
        /**
         * 获取公告列表
         */
        async loadTenderNoticeList() {
            const res = await getTenderNoticeList({ projectCode: this.projectCode })
            if (res.code === 200) {
                this.tableData = res.data.records || []

            } else {
                this.$message.error('获取公告列表失败')
            }
        },

        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },

        // 新增邀请书
        handleAddNew(vl, row) {
            if (vl == 'edit') {
                this.$router.push({ path: '/agentHome/addTenderAnnouncement', query: { projectCode: this.projectCode, type: vl, originalNoticeCode: row.tenderNoticeCode } })
            } else {
                this.$router.push({ path: '/agentHome/addTenderAnnouncement', query: { projectCode: this.projectCode, type: vl } })
            }
        },

        // 查看详情
        async handleViewDetail(row) {
            try {
                const res = await getTenderNoticeDetail({ tenderNoticeCode: row.tenderNoticeCode })
                if (res.code === 200) {
                    this.currentDetail = res.data
                    this.detailDialogVisible = true
                } else {
                    this.$message.error('获取公告详情失败')
                }
            } catch (error) {
                console.error('获取公告详情失败:', error)
                this.$message.error('获取公告详情失败')
            }
        },

        // 编辑
        handleEdit(row) {
            this.handleAddNew('edit', row)
        },

        // 删除
        handleDelete(row) {
            this.$confirm('确定要删除该招标公告吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteTenderNotice(row)
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
        /**
         * 删除公告
         */
        async deleteTenderNotice(row) {
            const res = await deleteTenderNotice({ tenderNoticeCode: row.tenderNoticeCode })
            if (res.code === 200) {
                this.$message.success('删除成功')
                this.loadTenderNoticeList()
            }
        },

        // 变更公告
        handleChangeAnnouncement(row) {
            this.$router.push({
                path: '/agentHome/addTenderAnnouncement',
                query: {
                    projectCode: this.projectCode,
                    type: 'change',
                    originalNoticeCode: row.tenderNoticeCode
                }
            })
        },

        // 分页相关方法
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },

        // 获取状态标签类型
        getStatusType(status) {
            const typeMap = {
                '0': 'info',      // 暂存
                '1': 'warning',   // 提交
                '2': 'danger',    // 退回
                '9': 'success'    // 发布
            }
            return typeMap[status] || 'info'
        },
        getBidSectionList(detail) {
            if (!detail || !Array.isArray(detail.bidSectionList)) {
                return []
            }
            return detail.bidSectionList
        }
    },

}
</script>

<style lang="less">
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 页面特定样式
// ============================================

// 页面头部优化（带按钮组）
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

// 删除按钮特殊样式
.delete-btn {
    color: @error-color !important;
    
    &:hover {
        color: darken(@error-color, 10%) !important;
    }
}

// ============================================
// 详情弹窗样式
// ============================================
.detail-dialog-panel {
    .el-dialog__body {
        padding: 12px 20px 0;
        background: #ffffff;
        .detail-content {
            padding: 20px;
            background: #ffffff;

            @detail-title-color: #222222;
            @detail-value-color: #8c8c8c;

            .detail-overview {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                gap: 16px;
                padding: 20px;
                margin-bottom: 20px;
                background: #fafafa;
                border-radius: 4px;

                .overview-main {
                    min-width: 0;
                    flex: 1;
                }

                .overview-kicker {
                    margin-bottom: 10px;
                    font-size: 12px;
                    line-height: 1;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                    color: #999;
                    font-weight: 600;
                }

                .overview-title {
                    font-size: 22px;
                    font-weight: 600;
                    line-height: 1.5;
                    color: @detail-title-color;
                    margin-bottom: 12px;
                    word-break: break-word;
                }

                .overview-code {
                    font-size: 14px;
                    color: @detail-value-color;
                    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
                }

                .overview-submeta {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                    margin-top: 16px;
                }

                .overview-stat {
                    min-width: 140px;
                    padding: 10px 14px;
                    border-radius: 4px;
                    background: #ffffff;
                    border: 1px solid #ebeef5;
                    display: flex;
                    flex-direction: column;
                    gap: 6px;

                    .stat-label {
                        font-size: 12px;
                        color: @detail-title-color;
                        line-height: 1;
                    }

                    .stat-value {
                        font-size: 16px;
                        line-height: 1.4;
                        color: @detail-value-color;
                        font-weight: 600;

                        &.stat-value--time {
                            font-size: 13px;
                            font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
                            color: @detail-value-color;
                        }
                    }
                }

                .overview-meta {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    flex-wrap: wrap;
                    justify-content: flex-end;

                    .el-tag {
                        height: 28px;
                        line-height: 26px;
                        padding: 0 12px;
                        border-radius: 4px;
                        border-color: #dcdfe6;
                        background: #ffffff;
                        color: #606266;
                        font-weight: 500;
                    }
                }
            }

            .detail-panel {
                margin-bottom: 20px;
                padding: 20px;
                background: #fafafa;
                border-radius: 4px;

                .panel-title {
                    margin-bottom: 16px;
                    font-size: 16px;
                    font-weight: 600;
                    color: @detail-title-color;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
            }

            .detail-grid {
                display: grid;
                grid-template-columns: repeat(2, minmax(0, 1fr));
                gap: 0 20px;

                &.detail-grid--compact {
                    gap: 0 20px;
                }
            }

            .detail-field {
                padding: 12px 0;
                border-bottom: 1px solid #f0f4f7;
                min-width: 0;
                display: flex;
                align-items: flex-start;

                &.field-span-2 {
                    grid-column: span 2;
                }

                .field-label {
                    min-width: 160px;
                    margin-bottom: 0;
                    padding-right: 12px;
                    font-size: 13px;
                    line-height: 1.7;
                    color: @detail-title-color;
                    font-weight: 500;
                }

                .field-value {
                    font-size: 14px;
                    line-height: 1.8;
                    color: @detail-value-color;
                    flex: 1;
                    word-break: break-word;

                    &.is-mono {
                        font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
                        font-size: 13px;
                        color: #666;
                    }
                }
            }

            .section-table {
                margin-top: 10px;
            }

            .empty-state {
                padding: 24px;
                border: 1px dashed #e4e7ed;
                border-radius: 4px;
                text-align: center;
                color: @detail-value-color;
                background: #fafafa;
            }

            .content-box {
                border: 1px solid #ebeef5;
                border-radius: 4px;
                background: #ffffff;
                overflow: hidden;
            }

            .notice-content {
                max-height: 420px;
                overflow-y: auto;
                padding: 20px;
                line-height: 1.9;
                color: @detail-value-color;
                word-break: break-word;

                p {
                    margin: 0 0 12px;
                }

                &::-webkit-scrollbar-thumb {
                    background: #d1d5db;
                    border-radius: 3px;

                    &:hover {
                        background: @gray-400;
                    }
                }
            }

            .remark-box {
                padding: 16px 18px;
                background: #ffffff;
                border: 1px solid #ebeef5;
                border-radius: 4px;
                line-height: 1.8;
                color: @detail-value-color;
                white-space: pre-wrap;
            }
        }
    }

    .dialog-footer {
        text-align: center;
        padding: 18px 0 8px;
        border-top: 1px solid #ebeef5;
        margin-top: 6px;

        .el-button {
            min-width: 110px;
            transition: all @transition-base ease;
            border-radius: 4px;
            border-color: #dcdfe6;
            color: #606266;
            background: #ffffff;

            &:hover {
                transform: translateY(-1px);
                color: #409EFF;
                border-color: #c6e2ff;
            }
        }
    }

    .el-dialog__header {
        padding: 20px 20px 0;
        background: #ffffff;
    }

    .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }

    .el-dialog__headerbtn {
        top: 20px;
        right: 20px;
    }

    .el-dialog__footer {
        padding: 0 20px 20px;
        background: #ffffff;
    }

    @media (max-width: 1200px) {
        .detail-content {
            .detail-overview {
                flex-direction: column;
                align-items: flex-start;

                .overview-meta {
                    justify-content: flex-start;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .detail-content {
            .detail-grid {
                grid-template-columns: 1fr;
            }

            .detail-field.field-span-2 {
                grid-column: span 1;
            }

            .detail-field {
                flex-direction: column;

                .field-label {
                    min-width: auto;
                    padding-right: 0;
                    margin-bottom: 6px;
                }
            }
        }
    }
}
</style>
